import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import api from './api';
import { AppThunk } from './app';
import API_URL from '../config/ApiUrl';

interface UserState {
  status: [];
  privilegesList: [];
  rolesList: [];
}

const initialState = {
  status: [],
  // privilegesList: [],
  // rolesList: [],
} as UserState;

const UserSlice = createSlice({
  name: 'User',
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<any>) => {
      state.status = action.payload;
    },
    // setPrivilegesList: (state, action: PayloadAction<any>) => {
    //   state.privilegesList = action.payload;
    // },
    // setRolesList: (state, action: PayloadAction<any>) => {
    //   state.rolesList = action.payload;
    // },
  },
});

export const { setStatus } = UserSlice.actions;

export const fetchAddUser =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.USER.ADD, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchListUser =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.USER.LIST, payload);
      return Promise.resolve(response.data.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchEditUser =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.USER.EDIT, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const fetchActiveUser =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.USER.EDIT, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchDeleteUser =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.USER.DELETE, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export default UserSlice.reducer;
